import { render, staticRenderFns } from "./louis-roederer.vue?vue&type=template&id=0b5d0994&scoped=true"
import script from "./louis-roederer.vue?vue&type=script&lang=js"
export * from "./louis-roederer.vue?vue&type=script&lang=js"
import style0 from "./louis-roederer.vue?vue&type=style&index=0&id=0b5d0994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5d0994",
  null
  
)

export default component.exports